// accountants/payroll-list
import React from 'react';
import View from 'src/pages/coming-soon';
import AppRender from 'src/routes/app-render';

const Page = () => {
  return (
    <AppRender>
      <View message={'Danh sách bảng lương của nhân viên. Lập báo cáo'} />
    </AppRender>
  );
};

export default Page;
